import { FormBuilder } from '@chipinside/formbuilder'

import { Dialog } from '#/components/Dialog'
import { useConfirmDialog } from '#/store/hooks/useConfirmDialog'
import { AllForms, BuildFormProps } from '#/store/hooks/useFormBuilder/types'
import { useForms } from '#/store/hooks/useForms'
import { Sentry } from '#/store/services/Sentry'

export const useFormBuilder = () => {
  const { confirm } = useConfirmDialog()
  const forms = useForms() as AllForms

  const build = <TFormName extends keyof AllForms, TFormType extends keyof AllForms[TFormName]>({
    afterSuccess,
    formName,
    formType,
    onClose,
    onSuccessAction,
    params,
    ...rest
  }: BuildFormProps<TFormName, TFormType>) => {
    const formFunction = forms?.[formName]?.[formType]

    // Note: TypeScript não consegue inferir corretamente o tipo aqui, então precisamos fazer um cast
    const form = (formFunction as any)({
      afterSuccess,
      build,
      confirm,
      onSuccessAction,
      params,
    })

    /**
     * Adiciona cor a partir do form.level
     * Se o form.level não existir, o botão não terá cor
     * Se o form.level existir, o botão terá a cor correspondente
     */
    const submitButtonWithLevel = form.level ? { props: { color: form.level } } : undefined

    Sentry.hitForm({ formName, formType } as any)

    Dialog.open({
      backdropDismissable: false,
      content: (
        <FormBuilder
          submitButton={submitButtonWithLevel}
          {...form}
          afterSuccess={form.afterSuccess ?? afterSuccess}
          {...rest}
          modal
          setWidth={({ width }) => Dialog.update({ maxWidth: width })}
        />
      ),
      header: {
        level: form.level,
        subtitle: form.subtitle,
        title: form.title,
      },
      maxWidth: form.width,
      onClose,
    })
  }

  return { ...forms, build, confirm }
}
